"use strict";
/**
 * Addresses on the venue LAN, checked the same way by the API, the staff app
 * and the schemas that guard them.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIpv4Address = isIpv4Address;
/**
 * A dotted-quad IPv4 address: four parts, each 0–255, no leading zeros
 * (Windows and adb read `010` as octal, so `192.168.1.010` is not the machine
 * the owner meant). No surrounding whitespace — trim first.
 *
 * IPv4 only on purpose. Every venue LAN this runs on hands out v4 leases; the
 * owner types the address Windows shows for the machine; a hostname would
 * need the gaming PCs to resolve it, which a venue LAN without its own DNS
 * cannot; and the bridge builds `ip:port` URLs that a v6 literal would need
 * brackets for. One rule, so the Central Device IP's field, its schema and
 * the `lanMediaBaseUrl` it becomes can never disagree (they were three copies
 * until 2026-09-24).
 */
function isIpv4Address(value) {
    const parts = value.split('.');
    return (parts.length === 4 &&
        parts.every((part) => /^(0|[1-9]\d{0,2})$/.test(part) && Number(part) <= 255));
}
//# sourceMappingURL=network.js.map